import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { toast } from '../hooks/use-toast';
import { Toaster } from './ui/toaster';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const FreeGuideSection = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !email.includes('@')) {
      toast({
        title: 'Invalid Email',
        description: 'Please enter a valid email address.',
        variant: 'destructive'
      });
      return;
    }

    setIsSubmitting(true);
    
    try {
      const response = await fetch(`${API_URL}/api/emails/send-free-guide`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      
      if (!response.ok) throw new Error('Failed to send');
      
      toast({
        title: 'Success!',
        description: 'Check your email! Your free guide has been sent.',
        variant: 'default'
      });
      
      setIsSubmitted(true);
      setEmail('');
    } catch (error) {
      console.error('Error sending email:', error);
      toast({
        title: 'Error',
        description: 'Failed to send email. Please try again.',
        variant: 'destructive'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <section id="free-guide" className="py-20 px-6 bg-[#3C2415]">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-[#C17855] text-sm uppercase tracking-wider mb-4 font-semibold">
            Free Download
          </p>
          
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            10 Ways to Spend Less This Week
          </h2>
          
          <p className="text-[#D4C7B8] text-lg mb-10">
            Get the free quick-start guide. 10 actionable strategies you can implement today — no email course, no drip sequence. Just the good stuff.
          </p>
          
          {isSubmitted ? (
            <div className="bg-[#6B7A5C] bg-opacity-20 border border-[#6B7A5C] rounded-lg p-6 max-w-md mx-auto">
              <p className="text-white text-lg font-semibold mb-2">Check your inbox!</p>
              <p className="text-[#D4C7B8] text-sm">Your free guide has been sent. Check spam if you don't see it.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto" data-testid="free-guide-form">
              <Input 
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email"
                className="flex-1 bg-white text-[#2C1810] px-6 py-6 rounded-lg border-none text-lg"
                disabled={isSubmitting}
                data-testid="free-guide-email-input"
              />
              <Button 
                type="submit"
                disabled={isSubmitting}
                className="bg-[#6B7A5C] hover:bg-[#5A6850] text-white px-8 py-6 text-lg rounded-lg transition-all whitespace-nowrap"
                data-testid="free-guide-submit-btn"
              >
                {isSubmitting ? 'Sending...' : 'Send It'}
              </Button>
            </form>
          )}
          
          <p className="text-[#A89884] text-sm mt-6">
            No spam. Unsubscribe anytime.
          </p>
        </div>
      </section>
      <Toaster />
    </>
  );
};

export default FreeGuideSection;
